import React, { useState, useEffect } from 'react';
import { getSystemStatus } from '@/lib/api';

const SystemStatusCard = () => {
    const [status, setStatus] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStatus = async () => {
            try {
                const data = await getSystemStatus();
                setStatus(data);
            } catch (err) {
                console.error("Failed to fetch system status", err);
            } finally {
                setLoading(false);
            }
        };

        fetchStatus();
        // Poll every 30 seconds for non-technical users
        const interval = setInterval(fetchStatus, 30000);
        return () => clearInterval(interval);
    }, []);

    if (loading) return (
        <div className="p-4 bg-slate-800/50 rounded-lg border border-slate-700 animate-pulse /* # nolint */">
            <div className="h-4 w-24 bg-slate-700 rounded mb-2"></div>
            <div className="h-6 w-48 bg-slate-700 rounded"></div>
        </div>
    );

    if (!status) return null;

    const isBlocked = status.status === 'BLOCKED' || status.status === 'FAIL';
    const colorClass = isBlocked ? 'text-rose-600 bg-rose-600/10 border-rose-600/20' : 'text-emerald-600 bg-emerald-600/10 border-emerald-600/20';

    return (
        <div className={`p-4 rounded-lg border transition-all ${colorClass}`}>
            <div className="text-xs font-semibold tracking-wider mb-1 opacity-70">
                System Operational Status
            </div>
            <div className="flex items-center gap-2">
                <div className={`w-2 h-2 rounded-full animate-pulse /* # nolint */ ${isBlocked ? 'bg-rose-500' : 'bg-emerald-500'}`} />
                <span className="font-semibold text-lg">{status.status}</span>
            </div>
            <div className="mt-2 text-sm leading-relaxed opacity-90">
                {status.reason}
            </div>
            <div className="mt-3 text-[10px] opacity-40 font-mono">
                Last Verified: {new Date(status.timestamp).toLocaleString()}
            </div>
        </div>
    );
};

export default SystemStatusCard;
